import React from 'react';
import { motion } from 'framer-motion';
import { useGame } from '../contexts/GameContext';
const Inventory = () => {
  const {
    collectedStars
  } = useGame();
  return <div data-id="element-73">
      <h2 className="text-xl font-bold mb-4" data-id="element-74">Your Inventory</h2>
      <div className="mb-4" data-id="element-75">
        <h3 className="font-bold mb-2" data-id="element-76">Stars</h3>
        <div className="bg-gray-700 p-3 rounded-md" data-id="element-77">
          {collectedStars.length > 0 ? <div data-id="element-78">
              <p className="mb-2" data-id="element-79">{collectedStars.length} stars collected</p>
              <div className="flex gap-2 flex-wrap" data-id="element-80">
                {collectedStars.map((starId, index) => <motion.div key={starId} className="w-8 h-8 flex items-center justify-center" initial={{
              scale: 0,
              rotate: -180
            }} animate={{
              scale: 1,
              rotate: 0
            }} transition={{
              delay: index * 0.1,
              type: 'spring',
              stiffness: 200,
              damping: 15
            }} data-id="element-81">
                    <motion.svg viewBox="0 0 24 24" width="24" height="24" fill="#FFD700" animate={{
                rotate: [0, 5, -5, 0],
                scale: [1, 1.1, 1]
              }} transition={{
                duration: 2,
                repeat: Infinity,
                delay: index * 0.2
              }} data-id="element-82">
                      <polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26" data-id="element-83" />
                    </motion.svg>
                  </motion.div>)}
              </div>
            </div> : <p className="text-gray-400" data-id="element-84">
              No stars collected yet. Explore the world!
            </p>}
        </div>
      </div>
      <div data-id="element-85">
        <h3 className="font-bold mb-2" data-id="element-86">Achievements</h3>
        <div className="space-y-2" data-id="element-87">
          <motion.div className={`bg-gray-700 p-3 rounded-md ${collectedStars.length >= 1 ? 'border-l-4 border-green-500' : 'opacity-50'}`} animate={collectedStars.length >= 1 ? {
          borderColor: ['#10b981', '#34d399', '#10b981']
        } : {}} transition={{
          duration: 1.5,
          repeat: Infinity
        }} data-id="element-88">
            <h4 className="font-bold" data-id="element-89">Star Collector</h4>
            <p className="text-sm" data-id="element-90">Collect your first star</p>
          </motion.div>
          <motion.div className={`bg-gray-700 p-3 rounded-md ${collectedStars.length >= 3 ? 'border-l-4 border-green-500' : 'opacity-50'}`} animate={collectedStars.length >= 3 ? {
          borderColor: ['#10b981', '#34d399', '#10b981']
        } : {}} transition={{
          duration: 1.5,
          repeat: Infinity
        }} data-id="element-91">
            <h4 className="font-bold" data-id="element-92">Star Hunter</h4>
            <p className="text-sm" data-id="element-93">Collect at least 3 stars</p>
          </motion.div>
          <motion.div className={`bg-gray-700 p-3 rounded-md ${collectedStars.length >= 5 ? 'border-l-4 border-green-500' : 'opacity-50'}`} animate={collectedStars.length >= 5 ? {
          borderColor: ['#10b981', '#34d399', '#10b981']
        } : {}} transition={{
          duration: 1.5,
          repeat: Infinity
        }} data-id="element-94">
            <h4 className="font-bold" data-id="element-95">Star Master</h4>
            <p className="text-sm" data-id="element-96">Collect all 5 stars</p>
          </motion.div>
        </div>
      </div>
    </div>;
};
export default Inventory;